<template>
  <div>
    <b-sidebar shadow="lg" v-model="show.form" right width="50%" bg-variant="white"
      title="Create Maintenance & Docking Plan" @toggle="show.form = !show.form">
      <template v-if="show.form">
        <FormTargetFleetAvailabilityYearly v-if="show.form" :showForm="show.form" :forms="form" @refetch="onSuccessSubmit" />
      </template>
    </b-sidebar>
    <div>
      <div class="d-flex justify-content-between align-items-center my-3">
        <div class="d-flex align-items-center">
          <b-input v-model="params.search" class="mx-2" style="max-width: 220px;" placeholder="Fleet Name..." />
          <v-multiselect v-model="params.vehicle_type_ids" placeholder="Fleet Type" label="name"
            :options="optionsFleetTypes" :multiple="true" required track-by="id" class="mr-2" style="width: 300px">
            <span slot="noResult">Fleet type not found.</span>
          </v-multiselect>
          <date-picker class="mr-2" type="year" v-model="params.year" />
          <b-button variant="primary" style="height: max-content; max-width: 100px;" class="w-100" @click="() => fetchData()">
            Apply&nbsp;Filter
          </b-button>
        </div>
        <div md="3" class="d-flex justify-content-end align-items-center">
          <b-button :disabled="loadingExport" @click="handleExportTargetAv" variant="outline-primary"
            style="height: max-content;" class="text-truncate mr-2">
            <b-spinner style="width: 16px; height: 16px;" class="mr-1" v-if="loadingExport"></b-spinner> {{
              loadingExport ?
                'Loading...' : 'Export Plan By Fleet' }}
          </b-button>
          <b-dropdown id="dropdown-left" text="Data Plan" variant="primary" class="m-2">
            <b-dropdown-item href="#" @click="show.form = true, selectedData = null">Create Data Plan</b-dropdown-item>
            <b-dropdown-item href="#" @click="showModal = true">Import Data Plan</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <template v-if="!loading">
        <div class="overflow-auto relative w-100">
          <table class="w-100 striped-table">
            <thead>
              <tr>
                <th rowspan="2" class="p-2 align-middle text-center text-black" style="background-color: #F2F2F2;">Action</th>
                <th rowspan="2" class="p-2 align-middle text-center text-black" style="background-color: #F2F2F2; min-width: 150px;">Fleet Name</th>
                <th
                  v-for="(month, idx) in months"
                  :key="month"
                  :colspan="3"
                  class="p-2 align-middle text-center text-dark"
                  :style="{ backgroundColor: monthColors[idx % monthColors.length] }"
                >
                  {{ month.toUpperCase() }}
                </th>
              </tr>
              <tr>
                <template v-for="(month, idx) in months">
                  <th :key="month + '-sub-availability'" class="p-2 text-center text-black" :style="{ backgroundColor: monthColors[idx % monthColors.length] }">Plan Availability</th>
                  <th :key="month + '-sub-breakdown'" class="p-2 text-center text-black" :style="{ backgroundColor: monthColors[idx % monthColors.length] }">Plan Breakdown</th>
                  <th :key="month + '-sub-docking'" class="p-2 text-center text-black" :style="{ backgroundColor: monthColors[idx % monthColors.length] }">Plan Docking</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(fleet, idx) in listPlanAvailabilities" :key="idx">
                <td class="text-center py-2">
                  <b-dropdown :id="`dd-${idx}`" text="Action" variant="outline-primary" class="m-2">
                    <b-dropdown-item href="#" @click="() => handleUpdate(fleet)">Update Plan</b-dropdown-item>
                    <b-dropdown-item href="#" @click="() => handleDelete(fleet)">Delete Plan</b-dropdown-item>
                  </b-dropdown>
                </td>
                <td>
                  <span class="badge badge-info p-2">{{ fleet.vehicle.name }}</span>
                </td>
                <template v-for="(month, idx) in fleet.plan_data">
                  <td :key="fleet.id + '-availability-' + idx" class="text-center p-2" style="min-width: 200px;">{{ parseFloat(month.plan_availability || 0).toFixed(2) }}%</td>
                  <td :key="fleet.id + '-breakdown-' + idx" class="text-center p-2" style="min-width: 200px;">{{ parseFloat(month.plan_breakdown || 0).toFixed(2) }}%</td>
                  <td :key="fleet.id + '-docking-' + idx" class="text-center p-2" style="min-width: 200px;">{{ parseFloat(month.plan_docking || 0).toFixed(2) }}%</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-4 d-flex align-items-center w-100 justify-content-end">
          <b-pagination class="mb-0 mr-3" @change="(page) => {
            meta.page = page
            fetchData()
          }" v-model="meta.page" :total-rows="meta.totalItems" :per-page="meta.perPage" first-number
            align="center"></b-pagination>
          <b-form-select plain v-model="meta.perPage" :options="limitOptions" style="width: 140px;"
            @input="fetchData"></b-form-select>
        </div>
      </template>
      <div v-else colspan="17" class="d-flex justify-content-center p-5 w-100">
        <b-spinner></b-spinner>
      </div>
    </div>
    <b-modal v-model="showModal" title="Import Data" ok-title="Submit" @ok="handleimportTargetAv"
      :loading="loadingImport">
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i class="fa fa-times cursor-pointer" @click="showModal = false"></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file v-model="importFile" type="file" class="form-control" accept=".xlsx, .xls, .csv" />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button v-if="!loadingExportTemplate" variant="outline-primary" class="mt-3 w-100"
          @click="handleExportTemplateAv">
          <i class="fa fa-download"></i> Download Template
        </b-button>
        <b-button v-else variant="outline-primary" class="mt-3 w-100">
          <b-spinner style="width: 18px; height: 18px;" class="mr-2"></b-spinner> Downloading
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showErrImport" title="Import Error Information" ok-only >
      <div style="overflow: auto; max-height: 70vh;">
        <table class="w-100">
          <thead>
            <th class="p-2" style="width: 30%;">Row Number</th>
            <th class="p-2">Message</th>
          </thead>
          <tbody>
            <template v-if="msgErrImport.length">
              <tr v-for="(item, index) in msgErrImport" :key="index">
                <td class="p-2 px-4">{{ item.rowNumber }}</td>
                <td class="p-2">{{ item.message }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { srActions, fleetsActions } from '@/src/Utils/helper'
import moment from '@/node_modules/moment/moment'
import FormTargetFleetAvailabilityYearly from '../FormTargetFleetAvailabilityYearly.vue'
import { saveAs } from 'file-saver'

export default {
  name: 'PlanByFleet',
  data() {
    return {
      listPlanAvailabilities: [],
      show: {
        form: false,
        remark: false,
      },
      selectedData: null,
      showErrImport: false,
      dateRange: [
        moment().startOf('year').format('YYYY-MM-DD'),
        moment().endOf('year').format('YYYY-MM-DD')
      ],
      showModal: false,
      showModalFilter: false,
      maintenance_or_task_types: [],
      remark: '',
      loading: false,
      loadingExportTemplate: false,
      loadingImport: false,
      loadingExport: false,
      params: {
        year: moment().toDate(),
        search: '',
        vehicle_type_ids: [],
        maintenance_or_task_types: []
      },
      optionsFleetTypes: [],
      optionsTaskType: [],
      user_id: JSON.parse(localStorage.getItem('profile')).id,
      meta: {
        page: 1,
        perPage: 10,
        totalItems: 10,
        totalPage: 1,
      },
      limitOptions: [
        { value: 10, text: "10 / Page" },
        { value: 25, text: "25 / Page" },
        { value: 50, text: "50 / Page" },
      ],
      importFile: null,
      msgErrImport: [],
      months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      monthColors: [
        '#A4B5FF', // Warna 1
        '#FFD17C'  // Warna 2
      ],
      form: {
        id: null,
        vehicle_type_ids: null,
        year: moment().toDate(),
        target_per_months: [
          {
            month: 1,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 2,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 3,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 4,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 5,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 6,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 7,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 8,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 9,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 10,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 11,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
          {
            month: 12,
            plan_availability: null,
            plan_breakdown: null,
            plan_docking: null,
            error_availability: true,
            error_breakdown: true,
            error_docking: true,
          },
        ],
        is_same_input: false,
        remark: '',
      },
    }
  },
  components: {
    FormTargetFleetAvailabilityYearly,
  },
  methods: {
    ...srActions,
    ...fleetsActions,
    async getMasterTaskType() {
      try {
        let params = this.$options.filters.cleanObject({
          page: 1,
          perPage: 9999,
          showAll: true,
          active: true,
          search: '',
          user_id: this.user_id
        })
        const { data } = await this.fetchMasterTaskType(params)
        this.optionsTaskType = data.map((el) => ({
          label: el.name,
          id: el.id,
        }))
      } catch (error) {
        console.log(error)
      }
    },
    async fetchData() {
      try {
        this.loading = true
        const params = {
          // user_id: this.user_id,
          ...this.meta
        }
        const body = {
          year: this.params.year ? parseInt(moment(this.params.year).format('YYYY')) : undefined,
          vehicle_type_ids: this.params?.vehicle_type_ids.map((val) => val.id),
          search: this.params?.search || null,
        }
        const { data } = await this.getTargetAvailabilityPlanYearlyVehicle({ body, params });
        this.listPlanAvailabilities = data.data
        this.meta.totalItems = data.meta.total_item
        this.meta.perPage = data.meta.per_page
        this.meta.totalPage = data.meta.total_pages
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getVehicleType() {
      this.optionsFleetTypes = []
      let { status, data } = await this.getFleetTypes()
      if (status === 'success') {
        this.optionsFleetTypes = data?.filter((val) => !['HEAVY EQUIPMENT', 'MOTHER VESSEL'].includes(val?.name))
      }
    },
    findMonth(data, month) {
      return data?.find((el) => el?.month == month)
    },
    getRowNumber(index) {
      return ((this.meta.page - 1) * this.meta.perPage) + (index + 1);
    },
    async handleExportTemplateAv() {
      try {
        this.loadingExportTemplate = true
        // New service: GET target-availability/import-template via dedicated action
        const res = await this.$store.dispatch('sr/getTemplateTargetAvDirect', {
          params: { user_id: this.user_id },
        })
        saveAs(res.data, 'template_target_av.xlsx')
        this.$swal({ title: 'Import Data Success', icon: 'success' })
      } catch (error) {
        console.log(error)
        this.$swal({ title: 'Failed Download Template', icon: 'error' })
      } finally {
        this.loadingExportTemplate = false
      }
    },
    async handleExportTargetAv() {
      try {
        this.loadingExport = true
        const body = {
          start_date: this.dateRange[0],
          end_date: this.dateRange[1],
          vehicle_type_ids: this.params?.vehicle_type_ids.map((val) => val.id),
          maintenance_or_task_types: this.params?.maintenance_or_task_types.map((val) => val.id),
        }
        const params = {
          user_id: this.user_id,
          perPage: 9999,
        }
        const res = await this.exportTargetAvailability({ body, params })
        saveAs(res.data, `PlanByFleet_${moment().format('DDMMYYYY')}.xlsx`)
        this.$swal({
          title: 'Success Export Data',
          icon: 'success',
        })
      } catch (error) {
        console.log(error)
        this.$swal({
          title: 'Failed Export Data',
          icon: 'error',
        })
      } finally {
        this.loadingExport = false
      }
    },
    async handleimportTargetAv() {
      try {
        this.loadingImport = true
        this.msgErrImport = []
        const formData = new FormData()
        formData.append('file', this.importFile)
        // Directly call target-availability/import via sr module, not importTargetAvailability helper
        const res = await this.$store.dispatch('sr/importTargetAvailabilityDirect', {
          body: formData,
          params: { user_id: this.user_id },
        })
        this.$swal({ title: 'Import Data Success', icon: 'success' })
      } catch (error) {
        console.log(error)
        const message = error?.data?.data?.rowCantInsert
        if (message?.length) this.msgErrImport = message
        this.$swal({
          title: 'Failed Import Data!',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
          didClose: () => { this.showErrImport = true },
        })
      } finally {
        this.loadingImport = false
        this.fetchData()
      }
    },
    getColorType(type) {
      switch (type) {
        case 'docking':
          return 'bg-warning text-white'
        case 'planning_maintenance':
          return 'bg-primary text-white'
        case 'running_maintenance':
          return 'bg-success text-white'
        case 'repair_maintenance_breakdown':
          return 'bg-yellow-custom text-black'
        case 'emergency_breakdown':
          return 'bg-danger text-white'
        default:
          return 'bg-secondary text-white'
      }
    },
    handleDelete(item) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          try {
            await this.deleteTargetAvailabilityYearlyVehicle(item.id)
            this.$swal('Success', 'Data has been deleted!', 'success')
            this.fetchData()
          } catch (error) {
            console.error(error)
            this.$swal('Error', 'Failed to delete data!', 'error')
          }
        }
      })
    },
    onSuccessSubmit() {
      this.show.form = false;
      this.fetchData();
    },
    handleUpdate(item) {
      this.form.id = item.id;
      this.form.vehicle_type_ids = item.vehicle_id;
      this.form.remark = item.remark;
      this.form.year = moment(`${item.year}-01-01`).toDate();
      this.form.target_per_months = item.plan_data.map((data) => {
        return {
          ...data,
          error_availability: true,
          error_breakdown: true,
          error_docking: true,
        }
      });
      this.show.form = true;
    }
  },
  mounted() {
    this.getMasterTaskType()
    this.fetchData()
    this.getVehicleType()
  },
}
</script>
<style scoped>
.bg-yellow-custom {
  background: #FDDA0D !important;
}
table td {
  color: #000 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.relative {
  position: relative;
}

.col-month {
  min-width: 160px;
}

.sticky {
  position: sticky !important;
}

.col-1 {
  left: 0px !important;
  z-index: 20;
  min-width: 40px;
}

.col-2 {
  left: 40px !important;
  z-index: 20;
  min-width: 200px;
  max-width: 200px;
}

.col-3 {
  left: 240px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}

.col-4 {
  left: 340px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}

.col-5 {
  left: 440px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
</style>
